<template>
  <div class="updates-form-wrapper">
    <HeroImage
      title="Sign up"
      subtitle="Get more information and updates <br>delivered straight to your inbox."
      :image="imageLg"
      :image__sm="imageSm"
      alt="Adult with ADHD managing her symptoms during work hours | JORNAY PM® (methylphenidate HCl extended-release capsules)"
    >
    </HeroImage>
    <div class="updates-form">
      <div class="updates-form__inner">
        <!-- <div class='updates-form-heading text-center d-flex flex-wrap justify-content-center align-content-end px-5'>
          <h1 class='updates-form-title mx-auto'>
            Sign up for updates and resources from <span class='no-wrap'>JORNAY PM</span>
          </h1>
          <h3 class='updates-form-subtitle'>
            Look for information and tips in your inbox.
          </h3>
        </div> -->
        <form
          action="https://go.pardot.com/l/231552/2022-11-30/2ykr21"
          method="POST"
          novalidate
          @submit.prevent="validate"
          class="updates-form__content"
          ref="form"
        >
          <b-row>
            <div class="col-md top-row p-0" :class="{ invalid: errors.has('profile_type') }">
              <span>All fields required.</span>
              <span
                v-if="errors.has('profile_type')"
                class="updates-form__answers-error mb-5 mb-md-0 mt-4 mt-md-0 text-red font-weight-bold"
                >Please select at least one option.</span
              >
            </div>
          </b-row>
          <b-row>
            <div class="col-md p-0">
              <div class="updates-form__answers__wrapper bg-gradient-145">
                <div class="updates-form__answers__wrapper-contents">
                  <p class="updates-form__answers-text text-left mt-0">
                    Choose all that apply.
                  </p>

                <label
                  class="def-radio"
                  v-for="(answer, answerIndex) in answers"
                  :key="answerIndex"
                >
                  <input
                    type="checkbox"
                    :value="String(answerIndex)"
                    class="def-radio__input"
                    name="profile_type_checkbox"
                    v-model="formValues.profile_type"
                    @change="errors.remove('profile_type')"
                  />
                  <span class="def-radio__input-box" :name="answerIndex"></span>
                  <span class="def-radio__input-text">{{ answer }}</span>
                </label>

                </div>
              </div>
            </div>
          </b-row>
          <b-row>
            <div class="col-md yes-no" :class="{ invalid: errors.first('answersYN') }">
              <p class="updates-form__answersYN-text">
                Are you <strong>OR</strong> your child currently prescribed
                JORNAY PM?
              </p>
              <span
                v-if="errors.first('answersYN')"
                class="def-input__error text-red d-block font-weight-bold"
                style="margin-bottom:10px;margin-top: -10px;"
                >Please specify Yes or No.</span
              >
              <div class="yes-no-selection">
                <label
                  class="def-radio yes-no-input"
                  v-for="(activity, answersYNIndex) in answersYN"
                  :key="activity"
                >
                  <input
                    type="radio"
                    :value="activity"
                    class="def-radio__input "
                    name="answersYN"
                    v-model="formValues.selectedAnswerYN"
                    @change="errors.remove('answersYN')"
                  />
                  <span class="def-radio__input-box"></span>
                  <span class="def-radio__input-text radio">{{ activity }}</span>
                </label>

              </div>
            </div>
          </b-row>
          <b-row>
            <div class="col-md">
              <DefInput
                v-model="formValues.firstName"
                v-validate="'required'"
                class="updates-form__input"
                :class="{ invalid: errors.first('first_name') }"
                id="first-name"
                text="Your first name"
                name="first_name"
                required
                :error="errors.first('first_name')"
              />
            </div>
            <div class="col-md">
              <DefInput
                v-model="formValues.lastName"
                v-validate="'required'"
                class="updates-form__input"
                :class="{ invalid: errors.first('last_name') }"
                id="last-name"
                text="Your last name"
                name="last_name"
                required
                :error="errors.first('last_name')"
              />
            </div>
          </b-row>
          <b-row>
            <div class="col-md">
              <DefInput
                v-model="formValues.email"
                v-validate="'required|email'"
                class="updates-form__input"
                :class="{ invalid: errors.first('email') }"
                id="email"
                text="Email address"
                name="email"
                ref="email"
                required
                :error="errors.first('email')"
              />
            </div>
            <div class="col-md">
              <DefInput
                v-model="formValues.emailConfirm"
                v-validate="'confirmed:email|required'"
                class="updates-form__input"
                :class="{ invalid: errors.first('email_second') }"
                id="emailConfirm"
                text="Confirm email address"
                name="email_second"
                required
                :error="errors.first('email_second')"
              />
            </div>
          </b-row>
          <b-row>
            <div class="col-md-6">
              <DefInputZip
                v-validate="'required'"
                v-model="formValues.ZIP"
                class="updates-form__input"
                :class="{ invalid: errors.first('zip_code') }"
                id="ZIP"
                text="ZIP Code"
                name="zip_code"
                :error="errors.first('zip_code')"
              />
            </div>
          </b-row>

          <DefCheckbox
            v-model="formValues.agreement"
            :value="agreementText"
            class="updates-form__checkbox"
            :class="{ invalid: errors.first('agreement') }"
            id="agreement"
            name="agreement"
            required
            :text="agreementText"
            :error="errors.first('agreement')"
            @change="errors.remove('agreement')"
          />

          <div v-if="errorMessage" class="text-danger font-weight-bold text-center mb-3">
            {{ errorMessage }}
          </div>

          <div class="updates-form__button-box">
            <button type="submit" class="def-btn def-btn--golden" :disabled="isSubmitting">
              {{ isSubmitting ? 'Signing up...' : 'Sign me up' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import DefInput from "../elements/DefInput";
import DefInputZip from "../elements/DefInputZip";
// import DefRadio from '../elements/DefRadio'
// import BigCheckboxButtons from '../elements/BigCheckboxButtons'
import DefCheckbox from "../elements/DefCheckbox";
import HeroImage from "../../components/elements/HeroImage.vue";
import imageLg from "@/assets/images/3_25/sign-up/hero@2x.webp";
import imageSm from "@/assets/images/3_25/sign-up/hero_s@2x.webp";

export default {
  name: "UpdatesForm",
  components: {
    DefInput,
    DefInputZip,
    // DefRadio,
    // BigCheckboxButtons,
    DefCheckbox,
    HeroImage,
  },
  data() {
    return {
      isSubmitting: false,
      errorMessage: "",
      formValues: {
        firstName: "",
        lastName: "",
        email: "",
        emailConfirm: "",
        ZIP: "",
        profile_type: [],
        selectedAnswerYN: "",
        agreement: false,
      },
      options: [
        {
          text: "I am a caregiver of a child age 6-11 with ADHD.",
          value: "Caregiver of a child 6-11",
        },
        {
          text: "I am a caregiver of a teen age 12-17 with ADHD.",
          value: "Caregiver of a Child 12-17",
        },
        {
          text: "I am an adult with ADHD.",
          value: "A Person Living With ADHD",
        },
        {
          text:
            'I am taking <span class="no-wrap">JORNAY PM</span> or am a caregiver of someone taking <span class="no-wrap">JORNAY PM</span>.',
          value: "Taking or Caregiver of JORNAY PM",
        },
      ],
      agreementText:
        "By opting in, you certify that you are at least 18 years of age and wish to receive information from Collegium Pharmaceutical, Inc., about ADHD and JORNAY PM, including website updates, educational information, patient support resources, treatment options, and other related information.",
      answers: [
        "I AM A CAREGIVER OF A CHILD AGED 6-11 WITH ADHD.",
        "I AM A CAREGIVER OF A TEEN AGED 12-17 WITH ADHD.",
        "I AM AN ADULT WITH ADHD.",
      ],
      answersYN: ["Yes", "No"],
      imageLg,
      imageSm,
    };
  },
  methods: {
    async validate(event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      this.errorMessage = "";
      this.errors.clear();

      let hasCustomErrors = false;
      if (!this.formValues.profile_type || !this.formValues.profile_type.length) {
        this.errors.add({
          field: 'profile_type',
          msg: 'Please select at least one option.'
        });
        hasCustomErrors = true;
      }

      if (!this.formValues.selectedAnswerYN) {
        this.errors.add({
          field: 'answersYN',
          msg: 'Please specify Yes or No.'
        });
        hasCustomErrors = true;
      }

      if (!this.formValues.agreement) {
        this.errors.add({
          field: 'agreement',
          msg: 'Please check the agreement box to continue.'
        });
        hasCustomErrors = true;
      }

      const isVeeValid = await this.$validator.validateAll();
      if (!isVeeValid || hasCustomErrors) {
        this.$nextTick(() => {
          const invalidElments = this.$refs.form
            ? this.$refs.form.getElementsByClassName("invalid")
            : [];
          if (invalidElments && invalidElments.length > 0) {
            this.$scrollTo(invalidElments[0]);
          } else if (this.$refs.form) {
            this.$scrollTo(this.$refs.form);
          }
        });
        return;
      }

      const payload = {
        email: this.formValues.email,
        first_name: this.formValues.firstName,
        last_name: this.formValues.lastName,
        zip_code: this.formValues.ZIP,
        email_confirm: this.formValues.emailConfirm,
        email_second: this.formValues.agreement,
        profile_type: Array.isArray(this.formValues.profile_type)
          ? this.formValues.profile_type.map(Number).sort((a, b) => a - b).join(",")
          : this.formValues.profile_type,
        prescribed: this.formValues.selectedAnswerYN === "" ? "" : this.formValues.selectedAnswerYN === "Yes" ? "True" : "False",
      };

      console.log('Enroll payload:', payload);
      this.isSubmitting = true;

      try {
        const baseUrl = process.env.VUE_APP_FUNCTION_API_URL || "https://jornaypmnewfuntionapp-fybthvhwgsbfc2b5.eastus-01.azurewebsites.net/api/";
        const code = process.env.VUE_APP_ENROLL_CODE ? `?code=${process.env.VUE_APP_ENROLL_CODE}` : "";
        const enrollUrl = `${baseUrl.replace(/\/?$/, "/")}` + `Enroll${code}`;

        const result = await this.$http.post(enrollUrl, payload);
        if (result && result.data && result.data.success === true) {
          sessionStorage.setItem("isSignUp", "true");
          this.$emit("hideForm");
        } else {
          const serverMsg = result && result.data && result.data.data ? result.data.data : "Unknown error";
          console.error("Enrollment failed:", serverMsg);
          this.errorMessage = "We could not process your sign-up at this time. Please try again later.";
        }
      } catch (err) {
        console.error("Enrollment request exception:", err);
        this.errorMessage = "We could not process your sign-up at this time. Please check your connection and try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  mounted() {
    const email = sessionStorage.getItem("emailResults");
    if (email && email.length) {
      this.formValues.email = this.formValues.emailConfirm = email;
      sessionStorage.removeItem("emailResults");
    }
    let emailResultSent = sessionStorage.getItem("emailResultsSend");
    if (emailResultSent === "true") {
      sessionStorage.setItem("emailResultsSend", "false");
    }
  },
};
</script>
<style>
.updates-form-wrapper .hero-image p {
  margin-bottom: 40px;
  @media (min-width: 900px) {
    margin-bottom: 120px;
  }
}
.updates-form-heading {
  background: transparent linear-gradient(180deg, #d2edfc 0%, #a5def3 100%) 0%
    0% no-repeat padding-box;
  padding-top: 30px;
  padding-bottom: 20px;

  @media (min-width: 900px) {
    min-height: 350px;
  }

  .updates-form-title {
    font-size: 36px;
    max-width: 890px;

    @media (min-width: 900px) {
      font-size: 43px;
    }
  }

  .updates-form-subtitle {
    font-weight: 800;
    font-size: 18px;
    text-transform: none;
    line-height: 1.6;
    max-width: 300px;
    width: 100%;

    @media (min-width: 768px) {
      font-size: 20px;
      max-width: none;
    }
  }
}
.top-row {
  height: 35px;
  @media (max-width: 900px) {
    height: 90px;
  }
  /* padding-bottom: 15px; */
  /* @media(max-width:768px){
        min-height: unset;
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
      } */
  span {
    &:first-of-type {
      position: absolute;
      @media (max-width: 768px) {
        position: relative;
        margin-bottom: 10px;
        display: block;
      }
    }
    &:nth-of-type(2) {
      text-align: center;
      margin-top: 2px;
      @media (max-width: 768px) {
        position: relative;
        margin-top: 0;
      }
    }
  }
}
.updates-form__content {
  margin-top: 53px;
  margin-bottom: 36px;
  @media (min-width: 900px) {
    margin-top: 71px;
    margin-bottom: 80px;
  }
  max-width: 934px;
  margin-left: 30px;
  margin-right: 30px;

  > .row {
    margin: 0;
    @media (min-width: 900px) {
      .col-md:first-child,
      .col-md-6:first-child {
        padding-left: 0;
      }
      .col-md:last-child {
        padding-right: 0;
      }
    }
  }

  @media (min-width: 992px) {
    margin-left: auto;
    margin-right: auto;
  }
  @media (max-width: 900px) {
    .sign-up-top {
      padding: 26px;
    }
  }
}

/* .updates-form__button-box {
  .def-btn {
    max-width: 205px;
  }
} */

.def-radio {
  display: flex;
  padding-left: 0;
  margin-bottom: 0;

  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
}

.yes-no-selection {
  display: flex;

  label:first-of-type {
    margin-right: 14px;
  }

  .def-radio__input-box {
    border-radius: 15px;
  }

  .def-radio__input-text {
    font-size: 16px;
    color: #414042;
    font-weight: 600;
  }

  .def-radio__input:checked + .def-radio__input-box {
    background-image: none;
    background-color: #f8c222;
  }
}

/* Hide the default radio button */
.def-radio__input {
  display: none;
}

/* Style the custom radio button box */
.def-radio__input-box {
  display: inline-block;
  min-width: 20px !important;
  height: 20px;
  border: 2px solid #414042;
  border-radius: 0;
  /* Make it square */
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  margin-right: 8px;
  background-color: #fff;
  @media (min-width: 992px) {
    margin-right: 13px;
  }
  opacity: 1;
}

.def-radio__input-text {
  font-weight: 800;
  font-size: 18px;
  margin-bottom: 10px;
  -webkit-font-smoothing: antialiased;
}

/* Style the custom radio button when checked */
.def-radio__input:checked + .def-radio__input-box {
  background-color: #fff;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g transform="translate(-304.5 -1142.461)"><g><line x2="16" y2="17" transform="translate(308.5 1146.961)" fill="none" stroke="%232da7df" stroke-width="3"/><line x1="15" y2="17" transform="translate(309.5 1145.961)" fill="none" stroke="%232da7df" stroke-width="3"/></g></g></svg>');
  background-size: cover;
  background-position: center;
}

/* Add some styling for hover and active states */
.def-radio__input-box:hover {
  border-color: #007bff;
}

.def-radio__input-box:active {
  border-color: #0056b3;
}

.def-input__label-text {
  margin-bottom: 14px;
  @media (min-width: 900px) {
    margin-bottom: 15px;
  }
}

.text-red {
  color: #d61515;
  margin-top: 6px;
  margin-bottom: 10px;
}
</style>